module.exports = __webpack_public_path__ + "static/media/thumbnail-piedras-amarillas.a185df0a.jpg";